__turbopack_context__.v({
  "board": "excel-grid-visual-module__hD5Tmq__board",
  "boardPill": "excel-grid-visual-module__hD5Tmq__boardPill",
  "boardRevealed": "excel-grid-visual-module__hD5Tmq__boardRevealed",
  "cellLayerVisible": "excel-grid-visual-module__hD5Tmq__cellLayerVisible",
  "edge": "excel-grid-visual-module__hD5Tmq__edge",
  "edgeSwept": "excel-grid-visual-module__hD5Tmq__edgeSwept",
  "headPct": "excel-grid-visual-module__hD5Tmq__headPct",
  "headerSlotGone": "excel-grid-visual-module__hD5Tmq__headerSlotGone",
  "layer": "excel-grid-visual-module__hD5Tmq__layer",
  "overflowRow": "excel-grid-visual-module__hD5Tmq__overflowRow",
  "pillLayer": "excel-grid-visual-module__hD5Tmq__pillLayer",
  "root": "excel-grid-visual-module__hD5Tmq__root",
  "row": "excel-grid-visual-module__hD5Tmq__row",
  "shapeCard": "excel-grid-visual-module__hD5Tmq__shapeCard",
  "shapeSquare": "excel-grid-visual-module__hD5Tmq__shapeSquare",
  "step": "excel-grid-visual-module__hD5Tmq__step",
  "stepLink": "excel-grid-visual-module__hD5Tmq__stepLink",
  "subjectLayer": "excel-grid-visual-module__hD5Tmq__subjectLayer",
  "track": "excel-grid-visual-module__hD5Tmq__track",
  "trackFill": "excel-grid-visual-module__hD5Tmq__trackFill",
});
